import React from "react";
import { Checkbox, Col, Form, Row } from "antd";
import { connect } from "dva";
import { WeekDays, WeekDaysMap } from "@/utils/enum";

const ShipmentRestrictedDaysFormItem = ({ name, configLang, disabled }) => {
  return (
    <Form.Item
      name={name}
      label={configLang.CoreService?.DayWeekUnavailable}
      rules={[
        {
          validator: (_, value) => {
            const selectedDays = typeof value === "string" ? value.split(",") : value;

            if (selectedDays === null) return Promise.resolve();
            if (selectedDays.length > 6) {
              return Promise.reject("Too many restricted days selected.");
            } else {
              return Promise.resolve();
            }
          },
        },
      ]}
    >
      <Checkbox.Group disabled={disabled} style={{ width: "100%", justifyContent: "flex-start" }}>
        <Row>
          <Col style={{ width: 70, margin: 2 }}>
            <Checkbox value={WeekDays.MONDAY}>{WeekDaysMap[WeekDays.MONDAY]}</Checkbox>
          </Col>
          <Col style={{ width: 70, margin: 2 }}>
            <Checkbox value={WeekDays.TUESDAY}>{WeekDaysMap[WeekDays.TUESDAY]}</Checkbox>
          </Col>
          <Col style={{ width: 70, margin: 2 }}>
            <Checkbox value={WeekDays.WEDNESDAY}>{WeekDaysMap[WeekDays.WEDNESDAY]}</Checkbox>
          </Col>
          <Col style={{ width: 70, margin: 2 }}>
            <Checkbox value={WeekDays.THURSDAY}>{WeekDaysMap[WeekDays.THURSDAY]}</Checkbox>
          </Col>
          <Col style={{ width: 70, margin: 2 }}>
            <Checkbox value={WeekDays.FRIDAY}>{WeekDaysMap[WeekDays.FRIDAY]}</Checkbox>
          </Col>
          <Col style={{ width: 70, margin: 2 }}>
            <Checkbox value={WeekDays.SATURDAY}>{WeekDaysMap[WeekDays.SATURDAY]}</Checkbox>
          </Col>
          <Col style={{ width: 70, margin: 2 }}>
            <Checkbox value={WeekDays.SUNDAY}>{WeekDaysMap[WeekDays.SUNDAY]}</Checkbox>
          </Col>
        </Row>
      </Checkbox.Group>
    </Form.Item>
  );
};

export default connect(({ configs }) => ({
  configLang: configs.configLang,
}))(ShipmentRestrictedDaysFormItem);
